require('../../../node_modules/angular-ui-router');
import uiRouterModule, * as uiRouter from '../../../node_modules/angular-ui-router';

import { default as RoutesRouterConfig } from '../routes';

export default angular
	.module('pretor.online.views', [ uiRouterModule ])
	.config([ '$stateProvider', '$urlRouterProvider', RoutesRouterConfig ]);

require('../pages/cached-pages/pages');
